import { createContext } from 'react'

import type { TokenContextType } from '../types/token.types'

// Create the token context
export const TokenContext = createContext<TokenContextType | undefined>(
  undefined
)
